var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hbox',{staticClass:"align-center info-box infos"},[_c('InfoSmallIcon',{staticClass:"info-icon"}),_c('p',{staticClass:"gip-label"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }